export default {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {
      fontFamily: 'monospace',
      minHeight: 63,
    },
    highlighter: {
      padding: '12px',
      border: '1px solid transparent',
    },
    input: {
      border: '1px solid #E3E3E3',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
      borderRadius: '8px',

      padding: '12px',
      outline: `1px solid ${window?.settings?.primary_color ?? '#1DBD6B'}`,
    },
  },

  suggestions: {
    left: '0',
    top: 'unset',
    bottom: '100%',
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
}
